<template>
    <div class="print-mode-finish-details is-full">
        <div class="title is-4 is-3-tablet is-flex is-align-items-center mb-0">
            {{ $t('checkout.configure.inputLabels.finishOptions') }}
        </div>

        <div class="surfacefinish" v-for="finish in surfaceFinishes">
            <p class="title is-5 has-text-weight-bold mb-1">
                {{ finish.properties.name }}
            </p>
            <p>{{ finish.properties.description }}</p>
        </div>
    </div>
</template>

<script lang="js">
export default {
    props: {
        surfaceFinishes: {
            type: Array,
            required: true,
        }
    }
}
</script>

<style>
.print-mode-finish-details {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}
</style>
